import { IIngredient } from "../../types/recipe";

export class IngredientDb {
  private dbName = "IngredientDB";
  private dbVersion = 2;
  private storeName = "ingredient";

  async initDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve();
      };

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };
    });
  }

  async addIngredient(ingredient: IIngredient, clear?: boolean): Promise<void> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    if (clear) {
      const clearRequest = store.clear();
      clearRequest.onsuccess = () => {
        console.log("cleared ingredients");
      };
    }

    return new Promise((resolve, reject) => {
        store.put(ingredient);

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  async addIngredients(ingredients: IIngredient[], clear?: boolean): Promise<void> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readwrite");
    const store = transaction.objectStore(this.storeName);

    if (clear) {
      const clearRequest = store.clear();
      clearRequest.onsuccess = () => {
        console.log("cleared ingredients");
      };
    }

    return new Promise((resolve, reject) => {
      ingredients.forEach((ingredient) => {
        store.put(ingredient);
      });

      transaction.oncomplete = () => {
        resolve();
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  }

  async getIngredients(): Promise<IIngredient[]> {
    const db = await this.getDB();
    const transaction = db.transaction(this.storeName, "readonly");
    const store = transaction.objectStore(this.storeName);

    return new Promise((resolve, reject) => {
      const request = store.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  private async getDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        reject(request.error);
      };

      request.onsuccess = () => {
        resolve(request.result);
      };
    });
  }
}
